import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { faqs } from '../data/mock';

const FAQ = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Find answers to common questions about our IT services
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq) => (
              <AccordionItem 
                key={faq.id} 
                value={`item-${faq.id}`}
                className="border-2 border-gray-200 rounded-xl px-6 hover:border-emerald-500/50 transition-all duration-300 bg-white shadow-sm hover:shadow-md"
              >
                <AccordionTrigger className="text-left text-lg font-semibold text-gray-900 hover:text-emerald-600 py-6 hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* Additional Help CTA */}
          <div className="text-center mt-12 p-8 bg-gradient-to-r from-gray-50 to-emerald-50 rounded-2xl border-2 border-emerald-100">
            <p className="text-lg text-gray-700 mb-3">
              Still have questions?
            </p>
            <button 
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              className="text-emerald-600 hover:text-emerald-700 font-bold text-lg underline underline-offset-4 transition-colors"
            >
              Contact Our Support Team →
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
